// Constants
import { API } from './constants';

// Utils
import { apiFetch, HEADERS } from '../shared/utils/api';
import { getRandomIntInclusive } from '../shared/utils/math';


class HomeApi {
  static fetchMapLayersByProjCatTree(token, query) {
    const headers = { token };
    const requestOptions = { headers };

    return apiFetch(API.HOME.MAP_LAYERS_BY_PROJ_CAT_TREE, requestOptions, query);
  }

  static fetchKMLBySourceBoundingBoxZoom(token, params, query = undefined) {
    const headers = {
      'Accept': HEADERS.ACCEPT.APP_OCTET_STREAM,
      token
    };
    const requestOptions = { headers };
    const { organizationId, geocodeLayerId, boundingBox, currentZoom, maxZoom } = params;
    const { north, east, south, west } = boundingBox;

    return apiFetch(
      API.HOME.KML_SOURCE_BOUNDINGBOX_ZOOM
        .replace(':organizationId', organizationId)
        .replace(':geocodeLayerId', geocodeLayerId)
        .replace(':north', north).replace(':east', east)
        .replace(':south', south).replace(':west', west)
        .replace(':currentZoom', currentZoom).replace(':maxZoom', maxZoom),
      requestOptions,
      query || { v_: `::${getRandomIntInclusive(0)}::` }
    );
  }

  static fetchProjectCategories(token) {
    const headers = { token };
    const requestOptions = { headers };

    return apiFetch(API.HOME.PROJECT_CATEGORIES, requestOptions);
  }

  static fetchMapLayersByLayer(token, username, params, query) {
    const headers = {
      token,
      j_username: username
    };
    const requestOptions = { headers };
    const { layerId = '' } = params;

    return apiFetch(
      API.HOME.MAP_LAYERS_BY_LAYER.replace(':layerId', layerId),
      requestOptions, query
    );
  }

  static fetchMapLayersByLayerSearch(token, params, query) {
    const headers = { token };
    const requestOptions = { headers };
    const { layerId = '' } = params;

    return apiFetch(
      (layerId
        ? API.HOME.MAP_LAYERS_BY_LAYER_SEARCH.replace(':layerId', layerId)
        : API.HOME.MAP_LAYERS_SEARCH
      ),
      requestOptions, query
    );
  }
}

export default HomeApi;
